import { useController } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';
import STATES from '@zenbusiness/graphql-commons-states/static/states';

import { buildFieldName } from '#client/utils/form';

import { FIELD_NAMES } from '../../constants';

export default function useStateField({ namePrefix, validation } = {}) {
  const { formatMessage } = useIntl();

  const defaultValidation = {
    required: formatMessage(
      { id: 'shopping.component.addressFieldset.stateField.error.required' },
      { label: 'State' }
    )
  };

  const fieldName = buildFieldName(FIELD_NAMES.STATE, namePrefix);

  const {
    field,
    fieldState: { error }
  } = useController({
    defaultValue: '',
    name: fieldName,
    rules: { ...defaultValidation, ...validation }
  });

  return {
    error,
    field: {
      ...field,
      value: field.value ?? ''
    },
    options: STATES
  };
}
